// Event-Definitionen - Zentrale Konfiguration
// Ausgelagert für bessere Wartbarkeit und Performance

export const EVENT_DEFINITIONS = {
  none: { 
    label: 'Kein Event', 
    emoji: '🌊', 
    color1: '#063c88', 
    color2: '#010817', 
    effects: ['wave', 'bubbles'],
    dateFrom: null,
    dateTo: null
  },
  winter: { 
    label: 'Winter', 
    emoji: '❄️', 
    color1: '#1e3a5f', 
    color2: '#0a1628', 
    effects: ['snow', 'snowman'],
    dateFrom: '04.01',
    dateTo: '28.02'
  },
  christmas: { 
    label: 'Weihnachten', 
    emoji: '🎄', 
    color1: '#1a472a', 
    color2: '#0d1f14', 
    effects: ['snow', 'snowman', 'christmas'],
    dateFrom: '01.12',
    dateTo: '27.12'
  },
  silvester: { 
    label: 'Silvester', 
    emoji: '🎆', 
    color1: '#1a1a2e', 
    color2: '#0f0f1a', 
    effects: ['fireworks', 'confetti'],
    dateFrom: '28.12',
    dateTo: '01.01'
  },
  newyear: { 
    label: 'Neujahr', 
    emoji: '🥂', 
    color1: '#2d2d44', 
    color2: '#141420', 
    effects: ['confetti', 'lucky'],
    dateFrom: '01.01',
    dateTo: '03.01'
  },
  carnival: { 
    label: 'Karneval', 
    emoji: '🎭', 
    color1: '#6b2d5b', 
    color2: '#1a0f16', 
    effects: ['confetti', 'carnival'],
    dateFrom: '10.02',
    dateTo: '05.03'
  },
  easter: { 
    label: 'Ostern', 
    emoji: '🐰', 
    color1: '#4a7c59', 
    color2: '#1a2d1f', 
    effects: ['easter'],
    dateFrom: '20.03',
    dateTo: '10.04'
  },
  summer: { 
    label: 'Sommer', 
    emoji: '☀️', 
    color1: '#0369a1', 
    color2: '#0c4a6e', 
    effects: ['sun', 'bubbles'],
    dateFrom: '01.06',
    dateTo: '31.08'
  },
  autumn: { 
    label: 'Herbst', 
    emoji: '🍂', 
    color1: '#8b4513', 
    color2: '#2d1608', 
    effects: ['leaves'],
    dateFrom: '01.09',
    dateTo: '30.11'
  },
  blackweek: { 
    label: 'Black Week', 
    emoji: '🖤', 
    color1: '#1a1a1a', 
    color2: '#000000', 
    effects: ['sparkle'],
    dateFrom: '17.11',
    dateTo: '24.11'
  },
  blackfriday: { 
    label: 'Black Friday', 
    emoji: '🏷️', 
    color1: '#1a1a1a', 
    color2: '#000000', 
    effects: ['sparkle', 'sale'],
    dateFrom: '25.11',
    dateTo: '27.11' 
  },
  spring: {
    label: 'Frühling',
    emoji: '🌸',
    color1: '#064e3b',
    color2: '#022c22',
    effects: ['bubbles'],
    dateFrom: '01.03',
    dateTo: '31.05'
  }
};

export const LUCKY_ITEMS = ['🍀', '🐷', '🐞', '🍄', '🧲', '🎰'];

export const SNOW_EVENTS = ['winter', 'christmas', 'christmas2'];
export const BUBBLE_EVENTS = ['none', 'summer'];
export const FIREWORK_EVENTS = ['silvester', 'newyear'];

// Auto-Event-Erkennung basierend auf Datum
export function detectCurrentEvent() {
  const now = new Date();
  const month = now.getMonth();
  const date = now.getDate();
  
  // Silvester-Periode (28.12 - 1.1)
  if ((month === 11 && date >= 28) || (month === 0 && date <= 1)) {
    return 'silvester';
  }
  
  // Weihnachten (1.12 - 27.12)
  if (month === 11 && date >= 1 && date <= 27) {
    return 'christmas';
  }
  
  // Winter (Januar - Februar)
  if (month === 0 || month === 1) {
    return 'winter';
  }
  
  // Frühling (März - Mai)
  if (month >= 2 && month <= 4) {
    if (month === 2 && date >= 20 || month === 3 && date <= 10) return 'easter';
    return 'spring';
  }
  
  // Sommer (Juni - August)
  if (month >= 5 && month <= 7) {
    return 'summer';
  }
  
  // Herbst (September - November)
  if (month >= 8 && month <= 10) {
    return 'autumn';
  }
  
  return 'none';
}

// Default-Einstellungen für Events
export const DEFAULT_EVENT_SETTINGS = {
  activeEvent: detectCurrentEvent(),
  snowIntensity: 50,
  bubbleIntensity: 30,
  showBrandLogos: true,
  eventOptions: {},
  backgroundColors: { 
    isGradient: true, 
    color1: '#063c88', 
    color2: '#010817', 
    angle: 180 
  },
  effects: {
    headerSnow: true,
    cardSnow: true,
    cardBubbles: true,
    menuBubbles: true,
    menuFigures: true,
    menuFireworks: true,
    headerClock: true,
    headerWeather: true,
    headerDate: true,
    headerWaves: true,
  }
};
